
import React from 'react';
import { useFormik } from 'formik';

import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { YesNoOptions } from '../../../../constants/Options';


interface MargaToleAddFormViewProps {
    handleFormSuccess: () => void;
}
const DesignationCreateView: React.FC<MargaToleAddFormViewProps> = ({ handleFormSuccess }) => {
    const initialValues = {
        name: "",
        name_nep: "",
        remarks: "",
        status: "",

    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("name_nep", values.name_nep);
            formData.append("remarks", values.remarks);
            formData.append("status", values.status);
            try {
                await postDataToTheServer(AppURL.PayrollURL + 'payroll/designation/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Designation Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='name'
                            label='Desination Name'
                            handleChange={handleChange}
                            value={values.name}
                            error={typeof errors.name === 'string' ? errors.name : undefined}
                            handleBlur={handleBlur}
                            touched={touched.name}
                            required={true}
                            placeholder='Enter Designation Name'
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Desination Name(Nepali)'
                            name='tole_name_nep'
                            value={values.name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={typeof errors.name_nep === 'string' ? errors.name_nep : undefined}
                            placeholder='Enter Designation Name(nepali)'
                            touched={touched.name_nep}
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='remarks'
                            label='Remarks'
                            handleChange={handleChange}
                            value={values.remarks}
                            error={typeof errors.remarks === 'string' ? errors.remarks : undefined}
                            handleBlur={handleBlur}
                            touched={touched.remarks}
                            required={false}
                            placeholder='Enter Remarks'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            placeholder='Select status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.status}
                            touched={touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default DesignationCreateView